import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import useCustomerInitiativeCreate from './CustomerInitiativeCreate.hook';
import CustomerInitiativeForm from 'components/CustomerInitiativeForm/CustomerInitiativeForm';
import Heading from 'components/Heading';
import MayaLayout from 'components/MayaLayout';
import Box from 'yoda-ui/components/Box';
import Loader from 'yoda-ui/components/Loader';

const CustomerInitiativeCreate: FC = () => {
  const { t } = useTranslation();
  const {
    loading,
    loadingEvent,
    parentStrategicImperative,
    handleSaveCustomerInitiativeForm,
    handleCancelCustomerInitiativeForm,
  } = useCustomerInitiativeCreate();

  return (
    <MayaLayout>
      <Heading>
        { t('maya_customer_initiative_form_title') }
      </Heading>

      {
        loading || loadingEvent
          ? (

            <Box display="flex" flexDirection="column" justifyContent="center" height="100%">
              <Loader center />
            </Box>
          )
          : (
            <CustomerInitiativeForm {
              ...{
                parentStrategicImperative,
                submitCallback: handleSaveCustomerInitiativeForm,
                cancelCallback: handleCancelCustomerInitiativeForm,
              }
            } />
          )
      }
    </MayaLayout>
  );
};

export default CustomerInitiativeCreate;
